var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.schema.class, 'fn-type-collection'],attrs:{"id":_vm.schema.id}},[_c('div',{staticClass:"fn-type-collection__single"},[(_vm.schema)?_c('fn-form-schema',{attrs:{"no-inject":"","schema":_vm.schema,"value":_vm.model,"name-key":_vm.nameKey},on:{"input":_vm.onInput}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }